import { Link } from "react-router-dom";
import { useState } from "react";
import { GetGiftcardtat } from "../../actions/giftcardtat.jsx";
import { GotoLogin } from "../../actions/renovarLog.jsx";

import style from "../../styles/grid.module.css";
import axios from "axios";
import { formatos } from "../../actions/formats.jsx";
import { Pencil, SquareX, CirclePlus, Gift } from "lucide-react";

const Abmgiftcardtat = () => {
   // const filtroTipo = 1; // productos
   const estados = ["Activo", "Cancelado", "Usado"];
   const [selectedStatus, setSelectedStatus] = useState(1);
   const { formatoNumero } = formatos();
   const token = localStorage.getItem("token");
   const url = process.env.REACT_APP_URL_DIR + "giftcardtat/";
   const giftcarddatos = GetGiftcardtat();
   const handleRemove = async (id) => {
      let text =
         "Se va a eliminar la compra selecionada!\nSelecione Aceptar or Cancelar.";
      if (window.confirm(text) === true) {
         const response = await axios.delete(url + id, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         });
         console.log("response: ", response);
         window.location.href = "/giftcardtat";
      }
   };

   const formatDate = (fecha) => {
      var newDate1 = fecha.substring(0, 10).split("-");
      var newdate2 = newDate1[2] + "/" + newDate1[1] + "/" + newDate1[0];
      return newdate2;
   };

   if (giftcarddatos?.message === "Token inválido") {
      return <GotoLogin />;
   }

   const giftcardList = Array.isArray(giftcarddatos) ? giftcarddatos : [];
   const totalsByStatus = giftcardList.reduce(
      (acc, item) => {
         const status = parseInt(item.cod_status) || 0;
         if (status >= 1 && status <= 3) {
            acc[status] += 1 //parseFloat(item.total) || 0;
         }
         return acc;
      },
      { 1: 0, 2: 0, 3: 0 },
   );
   const filteredGiftcards = giftcardList.filter(
      (item) =>
         selectedStatus === 0 || parseInt(item.cod_status) === selectedStatus,
   );

   return (
      <>
         <div className={style.tableCli}>
            <div>
               <div className={style.gridTitle}>
                  <h2>
                     <Gift />
                     &nbsp;&nbsp;Gift Cards Tattoo
                  </h2>
               </div>
            </div>
            <div>
               <div>
                  <Link
                     to={"/formGiftcardtat"}
                     className="dLink"
                     title="Alta Gift Card"
                     state={{
                        id_primary: 0,
                        id: 0,
                        companyId: 0,
                        descripcion: "",
                        total: 0,
                        tipoPago: 1,
                        serv_id: 0,
                        cod_status: 1,
                     }}
                  >
                     <CirclePlus className="lucidePlus" />
                  </Link>
                  &nbsp;&nbsp;
               </div>
            </div>
         </div>
         <div style={{ marginBottom: "12px", backgroundColor: "#f5f5f5", width:"65%",padding: "10px", borderRadius: "5px" }}>
            <label htmlFor="codStatusFilter">Filtrar por Estado:&nbsp;</label>
            <select
               id="codStatusFilter"
               value={selectedStatus}
               onChange={(e) => setSelectedStatus(parseInt(e.target.value))}
            >
               <option value={0}>Todos</option>
               <option value={1}>Activo</option>
               <option value={2}>Cancelado</option>
               <option value={3}>Usado</option>
            </select>
            &nbsp;&nbsp;&nbsp;
            <span style={{ color: "green", fontWeight: "bold" }}>
               Activo: {totalsByStatus[1]}
            </span>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <span style={{ color: "red", fontWeight: "bold" }}>
               Cancelado: {totalsByStatus[2]}
            </span>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <span style={{ color: "blue", fontWeight: "bold" }}>
               Usado: {totalsByStatus[3]}
            </span>
         </div>
         <div>
            <table style={{ width: "70%" }}>
               <thead>
                  <tr>
                     <th style={{ width: "15%" }}>Fecha</th>
                     <th style={{ width: "50%" }}>Nombre</th>
                     <th style={{ width: "20%" }}>Estado</th>
                     <th style={{ width: "20%" }}>Total</th>
                     <th style={{ width: "15%" }}>Acciones</th>
                  </tr>
               </thead>
               <tbody>
                  {filteredGiftcards &&
                     filteredGiftcards.map((insu) => {
                        return (
                           <tr
                              key={insu.id}
                              className={
                                 parseInt(insu.cod_status) === 2
                                    ? style.trdatosRed
                                    : style.trdatos
                              }
                           >
                              <td className={style.style_code}>
                                 {formatDate(insu.fecha)}
                              </td>
                              <td className={style.style_td}>
                              {insu.nombre} {insu.cliente_nombre && ` / ${insu.cliente_nombre}`  }
                              </td>
                              <td className={style.style_td}>{estados[parseInt(insu.cod_status) - 1]}</td>

                              <td className={style.style_total}>
                                 $ {formatoNumero(insu.total)}
                              </td>
                              <td className={style.aligncenter}>
                                 <Link
                                    to={"/formGiftcardtat"}
                                    className="dLink"
                                    state={{
                                       id_primary: insu.id_primary,
                                       id: insu.id,
                                       companyId: insu.companyId,
                                       nombre: insu.nombre,
                                       total: insu.total,
                                       documento_solicitante:
                                          insu.documento_solicitante,
                                       documento_cliente:
                                          parseInt(insu.documento_cliente) === 0
                                             ? " "
                                             : insu.documento_cliente,
                                       tipoPago: insu.tipoPago,
                                       usuario: insu.userId,
                                       serv_id: insu.serv_id,
                                       cod_status: insu.cod_status,
                                    }}
                                 >
                                    <Pencil className="lucide" />
                                    {/* <FcAcceptDatabase style={estilo} /> */}
                                 </Link>
                                 &nbsp;&nbsp;
                                 <SquareX
                                    className="lucideIconDel"
                                    onClick={() =>
                                       handleRemove(insu.id_primary)
                                    }
                                 />
                              </td>
                           </tr>
                        );
                     })}
               </tbody>
            </table>
         </div>
      </>
   );
};

export default Abmgiftcardtat;
